import styled from "@emotion/styled";
import { Tooltip } from "@mui/material";
import type { HTMLAttributes } from "react";

import { AiBadgeIcon } from "./svg";

type Props = HTMLAttributes<HTMLDivElement>;

export const AiBadge = (props: Props) => {
  return (
    <Tooltip
      title={
        <>
          Generated with AI. <br />
          You can hide this indicator in Application Preferences.
        </>
      }
      placement="top-end"
    >
      <Container {...props}>
        <StyledAiBadge height={18} width={16} />
      </Container>
    </Tooltip>
  );
};

const Container = styled.div`
  position: relative;
  color: ${({ theme }) => theme.surface};
  font-size: 9px;
`;

const StyledAiBadge = styled(AiBadgeIcon)``;
